import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';

import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarNav,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';

import { userActions } from '../../_actions';


const ConnectedSideBarNav = withRouter(AppSidebarNav);


class DefaultLayout extends Component {
  constructor (props) {
    super(props);
    this.state = {
      user: localStorage.getItem('user')
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    if (this.state.user) {
      dispatch(userActions.whoAmI());
    }
  }

  render() {
    if (!this.props.auth.channel) {
      return (<p>Loading..</p>)
    }
    return (
      <Router>
        <div className="app">
          <AppHeader fixed>
        <DefaultHeader auth={this.props.auth} user={this.state.user} history={this.props.history }/>
          </AppHeader>
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader />
              <AppSidebarForm />
              <ConnectedSideBarNav navConfig={navigation} {...this.props} />
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
            <main className="main">
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                    <route.component {...props} />
                  )} />)
                    : (null);
                },
                           )}
                <Redirect from="/" to="/dashboard" />
              </Switch>
            </main>
            <AppAside fixed hidden>
              <DefaultAside />
            </AppAside>
          </div>
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.authentication
  };
}

const connectedLoginPage = connect(mapStateToProps)(DefaultLayout);
export { connectedLoginPage as DefaultLayout };



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js